<template>
    <!-- sidenav -->
    <div class="sidenav">
      <ul>
        <li :class="page.class" v-for="page in pageList" :key="page.class" @click="currentPage(page)">
          <a><b class="txt">{{page.title}}</b></a>
        </li>
      </ul>
      <!-- <p class="go_user_btn fl" style="position: absolute; dispaly: block;
    z-index: 100;
    bottom: 2%;
    margin-left: 3px;
    width: 50px;
    height: 33px;" @click="goUserPage">사용자 페이지</p> -->
    </div>
    <!-- //sidenav -->
</template>

<script>

import Util from '@/util';

export default {
  data: () => ({
    isActive: false,
    pageList: [
      {
        class: 'm01',
        link: '/dashboard',
        title: '대시보드',
        isActive: false,
      }, {
        class: 'm02',
        link: '/statistics',
        title: '통계',
        isActive: false,
      }, {
        class: 'm03',
        link: '/manageMeetingRoom',
        title: '회의실',
        isActive: false,
      }, {
        class: 'm04',
        link: '/manageVideoMeetingRoom',
        title: '영상장비',
        isActive: false,
      }, {
        class: 'm07',
        link: '/manageHistory',
        title: '이력관리',
        isActive: false,
      },
      {
        class: 'm05',
        link: '/manageUsers',
        title: '사용자관리',
        isActive: false,
      },
      {
        class: 'm08',
        link: '/manageSystem',
        title: '관리',
        isActive: false,
      },
      // {
      //   class: 'm05',
      //   link: '/manageUsers',
      //   title: '사용자관리',
      //   isActive: false,
      // },
      // , {
      //   class: 'm08',
      //   link: '/manageSystem',
      //   title: '시스템관리',
      //   isActive: false,
      // }
    ]
  }),
  created () {
    if (!Util.hasSession(this, true)) return;
  },
  methods: {
    currentPage: function (obj) {
      this.pageList.forEach(element => {
        element.isActive = false;
      });
      this.$router.push(obj.link);
      obj.isActive = true;
    },
    goUserPage () {
      this.$router.push(`/kMeeting`);
    }
  }
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/home/LeftSide.vue